import React from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { ContractUserDB } from '../types';
import ButtonWithStartIconNonResponsive from '../../../../components/uiComponents/ButtonWithStartIconNonResponsive';

type Props = {
	onChangeWorker: (event: SelectChangeEvent) => void;

	contractUsers: ContractUserDB[] | null;
	contractUser: ContractUserDB | null;
	userId: string;
};

const SelectWorker = ({ onChangeWorker, contractUsers, contractUser, userId }: Props) => {
	const theme = useTheme();
	return (
		<>
			<Box
				component="div"
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					flexDirection: { xs: 'column', sm: 'row' },
					alignItems: 'center',

					background: 'white',
					paddingX: 0,
					paddingY: 0,
					marginTop: 0,
					marginBottom: 0,
					borderRadius: 2,
				}}>
				<FormControl variant="filled" sx={{ width: '100%' }}>
					<InputLabel id="car">Výběr řidiče</InputLabel>
					<Select labelId="user" value={userId} onChange={onChangeWorker} label="Výběr řidiče">
						<MenuItem value="">žádný řidič</MenuItem>
						{contractUsers &&
							contractUsers.map((item: ContractUserDB) => {
								return (
									<MenuItem
										key={item.id}
										value={item.userId}
										sx={{ color: !item.user.isActive ? theme.palette.error.dark : '' }}>
										{`${item.user.lastName}, ${item.user.firstName}`}
									</MenuItem>
								);
							})}
					</Select>
				</FormControl>
			</Box>
		</>
	);
};

export default SelectWorker;
